module.exports = __webpack_public_path__ + "img/HF.ff623414.png";